export const OPEN_ORDER_ACCESS_STORAGE_KEY = "open-order-access-token";

const normalizeToken = (value) => {
  const token = String(value ?? "").trim();
  return token && token.length <= 128 && /^[A-Za-z0-9_-]+$/.test(token) ? token : "";
};

export const storeOpenOrderAccessToken = (value) => {
  const token = normalizeToken(value);
  if (!token) return "";
  window.sessionStorage.setItem(OPEN_ORDER_ACCESS_STORAGE_KEY, token);
  return token;
};

export const getStoredOpenOrderAccessToken = () =>
  normalizeToken(window.sessionStorage.getItem(OPEN_ORDER_ACCESS_STORAGE_KEY));

export const captureOpenOrderAccessToken = () => {
  const hasFragment = Boolean(window.location.hash);
  const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const token = hasFragment
    ? normalizeToken(fragment.get("access_token"))
    : getStoredOpenOrderAccessToken();
  if (hasFragment) {
    window.sessionStorage.removeItem(OPEN_ORDER_ACCESS_STORAGE_KEY);
    if (token) storeOpenOrderAccessToken(token);
    window.history.replaceState(
      null,
      document.title,
      `${window.location.pathname}${window.location.search}`,
    );
  }
  return token;
};

export const buildOpenOrderStatusPath = (token) =>
  `/OpenOrder/Status#access_token=${encodeURIComponent(normalizeToken(token))}`;

export const buildOpenOrderViewPath = (token) =>
  `/OpenOrder/ViewOrder#access_token=${encodeURIComponent(normalizeToken(token))}`;

export const redirectToOpenOrderView = (token) => {
  window.location.assign(buildOpenOrderViewPath(token));
};
